/* Bikers Wear product page — "Buy it now" (adds the chosen variant + ticked kit extras, then goes to
   checkout) and the quote dialog (quantity + option copied in). Works alongside esh-product.js. */
(function () {
  'use strict';
  var root = document.querySelector('[data-esp]');
  if (!root) return;
  var form = document.getElementById('esp-form');
  var atc = root.querySelector('[data-esp-atc]');
  var now = root.querySelector('[data-esp-now]');
  var idInput = root.querySelector('[data-esp-id]');
  var qty = root.querySelector('[data-esp-qty-input]');
  var msg = root.querySelector('[data-esp-msg]');
  function q() { return Math.max(1, parseInt(qty && qty.value, 10) || 1); }

  /* WhatsApp: Liquid url_encode writes spaces as "+"; use %20 so the message reads cleanly in every WhatsApp app */
  Array.prototype.forEach.call(root.querySelectorAll('a[href*="wa.me/"]'), function (a) { a.href = a.getAttribute('href').replace(/\+/g, '%20'); });

  /* Buy it now follows the Add to basket state (hidden when sold out / not available) */
  function sync() { if (now && atc) now.hidden = atc.disabled; }
  if (atc && window.MutationObserver) new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
  sync();

  if (now) now.addEventListener('click', function () {
    if (!idInput || now.classList.contains('is-busy') || (atc && (atc.disabled || atc.classList.contains('is-busy')))) return;
    var items = [{ id: +idInput.value, quantity: q() }];
    Array.prototype.forEach.call(root.querySelectorAll('[data-esp-kit-item]:checked'), function (c) { items.push({ id: +c.value, quantity: 1 }); });
    now.classList.add('is-busy'); now.textContent = 'Going to checkout…';
    if (msg) { msg.textContent = ''; msg.className = 'esp-msg'; }
    function fail(t) { now.classList.remove('is-busy'); now.textContent = 'Buy it now'; if (msg) { msg.textContent = t || 'Could not start checkout — please try again.'; msg.className = 'esp-msg is-error'; } }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) { if (!res.ok) { fail(res.body && (res.body.description || res.body.message)); return; } window.location.href = '/checkout'; })
      .catch(function () { fail(); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted && now) { now.classList.remove('is-busy'); now.textContent = 'Buy it now'; } });

  /* quote dialog */
  var dlg = document.getElementById('esp-quote');
  var opener = root.querySelector('[data-esp-quote-open]');
  if (!dlg) return;
  function open() {
    var qq = dlg.querySelector('[data-esp-quote-qty]'); if (qq) qq.value = q();
    var qv = dlg.querySelector('[data-esp-quote-variant]');
    if (qv) { var sel = Array.prototype.map.call(root.querySelectorAll('[data-esp-opt] input:checked'), function (i) { return i.value; }); if (sel.length) qv.value = sel.join(' / '); }
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
    var f = dlg.querySelector('#esp-q-name'); if (f && !dlg.querySelector('[data-esp-quote-done]')) f.focus();
  }
  function close() { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); if (opener) opener.focus(); }
  if (opener) opener.addEventListener('click', open);
  var x = dlg.querySelector('[data-esp-quote-close]'); if (x) x.addEventListener('click', close);
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  if (dlg.querySelector('[data-esp-quote-done]')) open();
})();